import { createContext, useContext } from 'react'

interface IWidgetContext {
  shadowRoot: ShadowRoot
  portalContainer: HTMLDivElement
}

export const WidgetContext = createContext<IWidgetContext | null>(null)

export const useWidgetContext = (): IWidgetContext | null => {
  return useContext(WidgetContext)
}

export const usePortalContainer = (): Element => {
  const ctx = useContext(WidgetContext)
  return ctx?.portalContainer ?? document.body
}
